import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'

import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(ScrollTrigger, SplitText);


import _map from 'lodash.map'
import _sample from 'lodash.samplesize'



class Challenge extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
    this.i = 0


    this.ref = {
     title: [],
     tit: [],
     spin: null,
     slot: []
    }

  }

  mount() {

    this.getItems()


    this.ref.title.forEach((item, i) => {

        const title = new SplitText(item, {
            type: "words",
            wordsClass: 'word'
        })

        title.words.forEach((item, i) => {
            item.style = `--word-index: ${i}`
        })


        //$(item).addClass('visible')

        ScrollTrigger.create({
            trigger: item,
            start: "top 90%",
            onEnter: () => {
                item.classList.add("visible")
            },
            once: true
        });


    })

    this.ref.tit.forEach((item, i) => {


        ScrollTrigger.create({
            trigger: item,
            start: "top 90%",
            onEnter: () => {
                item.classList.add("visible")
            },
            once: true
        });


    })

   

    this.ref.spin.addEventListener('click', (e)=>{
        this.spin()
    })

 
    } 

    spin(){
        this.populate(49)

        this.ref.slot.forEach((slot, i) => {


            const tl = gsap.timeline();
            tl.call(()=>{slot.classList.add('animate')},null, 0)
            tl.to(slot, {
                yPercent: 98,
                duration: 1.5 + i * 0.1,
                ease: 'power4.inOut',
                onComplete: this.complete.bind(this),
                onCompleteParams: [slot]
            }, 0)
            tl.call(()=>{slot.classList.remove('animate')},null, "-=.6")

            // gsap.to(slot, {
            //     yPercent: 98 ,
            //     duration: 1.5 + i*0.1, 
            //     ease: 'power4.out',
            //     onComplete: this.complete.bind(this), 
            //     onCompleteParams: [slot]
            // })



        })
    }

    complete(slot){

       
        while (slot.children.length > 1) {
            slot.removeChild(slot.lastElementChild);

          //  console.log(slot.children.length);
        }
        gsap.set(slot, {
            yPercent: 0
        })


      
    }
    
    populate(num){
         this.ref.slot.forEach((slot, i) => {

             const arr = slot.dataset.slot
             const sample = this.getSample(arr, num)

             sample.forEach((item, i)=>{
                 const box = document.createElement("div");
                 box.classList.add("slot");
                 box.textContent = item
                 slot.prepend(box)
             })

         })
    }


    getSample(slot, num){

      //  console.log(this.json);

       const sample =  _sample(this.json[slot], num);

       if(sample.length < num ) {
         const newsample = []
         for (let i = 0; i <= num; ++i){
            newsample[i] = gsap.utils.wrap(sample, i)
         }
         return newsample;
       }
       else {
        return sample;
       }

    }
    
    
    getItems(){

          fetch('/data/data.json')
            .then((response) => response.json())
            .then((json) => {

            //   this.facestock = json[0].facestock;
            //   this.adhesive = json[0].adhesive;
            //   this.liner = json[0].liner;
            //   this.ink = json[0].ink;
            //   this.size = json[0].size;

                this.json = json[0]
                this.populate(1)
   
            });
    }



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Challenge



